<template>
  <div
    id="uwf"
    class="flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default"
  >
    <div>
      <h2 class="modal-heading">
        {{ changeCase('you have unpublished changes', ElementE.TITLE) }}
      </h2>
      <p class="modal-content mt-1">
        {{ changeCase('if you leave now, your changes will be discarded.', ElementE.SUBTITLE) }}
      </p>
    </div>

    <div class="flex gap-4 self-end">
      <button class="btn-secondary is-btn-size-default" @click="$emit('discardChanges')">
        {{ changeCase('discard changes', ElementE.BUTTON) }}
      </button>
      <button class="btn-primary is-btn-size-default" @click="$emit('returnToEditing')">
        {{ changeCase('return to editing', ElementE.BUTTON) }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

export default defineComponent({
  name: "UpdateWidgetModal",
  components: {},
  data() {
    return {
      changeCase: changeCase,
      ElementE: ElementE,
    }
  }
});
</script>
